import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { AuthSsoService } from './auth-sso.service';
import { NbToastrService } from '@nebular/theme';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private lastErrorTime = 0;
  private readonly ERROR_DEBOUNCE_TIME = 3000;
  private isRedirecting = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private toastService: NbToastrService,
    private injector: Injector,
    private zone: NgZone, // Tambahkan NgZone
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse): Observable<any> => {
        const currentTime = Date.now();
        const shouldShowToast =
          currentTime - this.lastErrorTime > this.ERROR_DEBOUNCE_TIME;

        if (error.status === 401 || error.status === 403) {
          const isAlreadyOnLogin = this.router.url.includes('/auth/login');

          if (!this.isRedirecting && !isAlreadyOnLogin) {
            this.isRedirecting = true;

            const authSso = this.injector.get(AuthSsoService);
            authSso.forceLocalCleanupOnly();

            this.zone.run(() => {
              this.toastService.danger(
                'Sesi Anda telah berakhir. Silakan login kembali.',
                'Sesi Berakhir',
                { duration: 4000 },
              );

              setTimeout(() => {
                this.router.navigate(['/public-monitor']).then(() => {
                  setTimeout(() => {
                    this.isRedirecting = false;
                  }, 3000);
                });
              }, 500);
            });
          }

          return throwError(() => error.error?.message || error.message);
        }

        if (shouldShowToast) {
          let message = this.extractErrorMessage(error);
          this.zone.run(() => {
            this.toastService.danger(message, 'Error Occurred');
          });
          this.lastErrorTime = currentTime;
        }

        return throwError(() => error);
      }),
    );
  }

  private extractErrorMessage(error: HttpErrorResponse): any {
    if (error.error?.data?.errors) {
      return error.error.data.errors;
    } else if (error.error?.errors && typeof error.error.errors === 'object') {
      let arr_msg: any[] = [];
      Object.values(error.error.errors).forEach((val) => {
        arr_msg.push(val);
      });
      return arr_msg;
    } else if (error.error?.errors && Array.isArray(error.error.errors)) {
      return error.error.errors;
    } else if (error.error?.message) {
      return error.error.message;
    } else {
      return 'Terjadi Kesalahan';
    }
  }
}
